var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/activityfeed/parts/getcpmactivities',["require", "exports", "common/parts", "areas/activityfeed/models/dto"], function (require, exports, Parts, Dto) {
    "use strict";
    var GetCPMActivities = (function (_super) {
        __extends(GetCPMActivities, _super);
        function GetCPMActivities(baseUrl) {
            _super.call(this);
            this._baseUrl = baseUrl;
        }
        GetCPMActivities.prototype.process = function (symbol) {
            var _this = this;
            try {
                var url = this._baseUrl + "/sdn/rest/api/cpm/activitiesapicontract/" + symbol.clientId + "?organization=" + symbol.officeId + "&session=" + symbol.sessionId;
                Q(jQuery.ajax(url, {
                    type: "GET",
                    async: true,
                    beforeSend: function (xhr, settings) {
                        xhr.setRequestHeader("Authorization", "Bearer " + symbol.token.access_token);
                    },
                    contentType: "application/json"
                }))
                    .then(function (response) {
                    var activities = response.activities;
                    var result = new Dto.ActivitiesResponse();
                    result.token = symbol.token;
                    result.sessionId = symbol.sessionId;
                    result.organizationId = symbol.organizationId;
                    result.officeId = symbol.officeId;
                    result.clientId = symbol.clientId;
                    result.activities = Enumerable.From(activities).Where(function (x) { return x.firmIsResponsible === false; }).ToArray();
                    _this.output.call(result);
                });
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return GetCPMActivities;
    }(Parts.Part));
    return GetCPMActivities;
});

